export default __webpack_public_path__ + "static/media/LM_face.d0b35fec.png";